export enum DeliveryMessageStatus {
  DRAFT = 'draft',
  TEMPORARY_SAVE = 'temporary_save',
  TEST_PUSH = 'tested_push',
  COMPLETED = 'completed',
  WAITING = 'waiting',
}

export enum JobStatus {
  WAITING = 'waiting',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export enum DeliveryMessageType {
  DELIVERY_BY_FILE = 'file',
  DELIVERY_BY_INDIVIDUAL = 'individual',
}
